<template>
  <div>
    <div>
      <span class="xbed-sub-title">房间不参与活动、卡券</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>房间不参与活动、卡券</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form @submit.native.prevent='preventSubmit' inline>
      <FormItem label='卡劵/活动：' :label-width='90'>
        <Input v-model.trim="queryKeyWords.filter.title" style="width:250px"></Input>
      </FormItem>
      <FormItem label='房间：' :label-width='90'>
        <Input v-model.trim="queryKeyWords.filter.roomName" style="width:250px"></Input>
      </FormItem>
      <FormItem label='卡券/活动简介：' :label-width='120'>
        <Input v-model.trim="queryKeyWords.filter.description" style="width:250px"></Input>
      </FormItem>
      <FormItem>
        <Button type='primary' @click="queryKeyWordsBtn">查询</Button>
      </FormItem>
    </Form>
    <Table stripe :columns='columns' :data='dataList' :loading='listLoading'></Table>
    <div style="margin:10px;overflow:hidden">
      <Page show-sizer placement='top' :current="queryKeyWords.page" :total="listTotal" :page-size="queryKeyWords.size" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
import Moment from "moment";
export default {
  created () {
    this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );
  },
  data () {
    return {
      queryKeyWords:{
        url:'/MarketingIncludeRoom/list',
        page:1,
        size:10,
        filter:{
          title:'',
          roomName:'',
          description:''
        },
        sort:'',
        orderBy:''
      },
      dataList:[],
      listTotal:0,
      listLoading:false,
      columns:[
        {
          title:'id',
          key:'id',
          align:'center',
          width:100
        },
        {
          title:'业主id',
          key:'ownerId',
          align:'center',
          width:100
        },
        {
          title:'房间id',
          key:'roomId',
          align:'center',
          width:100
        },
        {
          title:'卡券/活动',
          key:'couponCardTitle',
          align:'center',
          width:250,
          render:(h,params)=>{
            const span = params.row.activityId ? params.row.activityTitle : params.row.couponCardTitle
            return h('div',{},span)
          }
        },
        {
          title:'房间',
          key:'roomName',
          align:'center',
          width:300
        },
        {
          title:'卡券/活动简介',
          key:'couponCardDesc',
          align:'center',
          width:300,
          render:(h,params)=>{
            const span = params.row.activityId ? params.row.activityDesc : params.row.couponCardDesc
            return h('div',{},span)
          }
        },
        {
          title:'禁止时间',
          key:'createdAt',
          align:'center',
          width:200,
          render:(h,params) =>{
            const createdAt = params.row.createdAt ? Moment(params.row.createdAt).format('YYYY-MM-DD HH:mm:ss'):''
            return h('div',{},createdAt)
          }
        },
      ]
    }
  },
  mounted() {
    this.$Notice.config( {
			top: 200
		} );
    this.queryList()
  },
  methods: {
    async queryList(){
      if ( !Utils.hasPermission( 'marketing_room_exclude' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      let params = {
        url:this.queryKeyWords.url,
        page:this.queryKeyWords.page - 1,
        size:this.queryKeyWords.size,
        filter:JSON.stringify(this.queryKeyWords.filter),
        sort:this.queryKeyWords.sort,
        orderBy:this.queryKeyWords.orderBy,
      }
      this.listLoading = true
      let resp = (await API.omsAPI[this.env].marketing.noJionRoom('GET',params,this.token)).data
      this.listLoading = false
      if (resp.retCode) {
				this.$Notice.error({
					title: '获取列表数据异常',
					desc: resp.msg
        })
				return
      }
      this.dataList = resp.content
      this.listTotal = resp.total
    },
    queryKeyWordsBtn(){
      this.queryKeyWords.page = 1
      this.queryList()
    },
    changePage(page){
      this.queryKeyWords.page = page
      this.queryList()
    },
    changePageSize(pageSize){
      this.queryKeyWords.page = 1
      this.queryKeyWords.size = pageSize
      this.queryList()
    },
    preventSubmit(){
      return false
    }
  },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/marketing/marketingExcludeRoom.vue